import React, { useCallback, useEffect, useState } from 'react';
import Collections from '@common/components/Collections';
import PropTypes from 'prop-types';
import {
  TextField,
  InputAdornment,
  Tabs,
  Tab,
  Box
} from '@mui/material';
import { Link } from 'react-router-dom';
import SearchItem from './components/SearchItem';
import BeddingSearchItem from './components/BeddingSearch';
import apiUrl from '@common/utils/apiURL';
import axios from 'axios';
import NoResults from '@common/components/NoResults';
import axiosInstance from '@common/utils/axiosInstance';
import { resetPreSelectedFilters } from '@common/utils/utils';
import { getAuthToken, isUserLoggedIn } from '@common/utils/auth/authService';
import useApi from '@common/utils/useApi';
import { useDispatch } from 'react-redux';
import Favourites from '@pages/Shop/view/components/Favourites';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


function Search() {
  const [switchTabValue, setSwitchTabValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoadingValue, setIsLoadingValue] = useState(true);
  const [collectionArr, setCollectionArr] = useState([]);
  const [materialArr, setMaterialArr] = useState([]);
  const [beddingArr, setBeddingArr] = useState([]);

  const switchHandleChange = (event, newValue) => {
    setSwitchTabValue(newValue);
  };




  // Define the search function
  const searchApiForBedding = async (term) => {
    // Call your search API here
    const searchURL = apiUrl.shop.search(term, 1, 20);
    await axiosInstance.get(searchURL)
      .then((response) => {
        if (response.status === 200) {
          const resData = response?.data?.data || []
          setBeddingArr(resData)
          setCollectionArr([])
          setMaterialArr([])
          setIsLoadingValue(false);
        }
      })
      .catch((error) => {
        console.log('Fabric Search request failed', error);
        setIsLoadingValue(false);
      })
  };

  const searchApiForFabric = async (term) => {
    // Call your search API here
    const searchURL = apiUrl.search(term);
    await axiosInstance.get(searchURL)
      .then((response) => {
        if (response.status === 200) {
          setBeddingArr([])
          setCollectionArr(response.data.collections)
          setMaterialArr(response.data.materials)
          setIsLoadingValue(false);
        }
      })
      .catch((error) => {
        console.log('Bedding Search request failed', error);
        setIsLoadingValue(false);
      })
  };

  // const [firstLoad, setFirstLoad] = useState(false);
  // const validateSearchTerm = useCallback((val) => {
  //   if (firstLoad)
  //     searchApiForFabric(val)
  //   else
  //     setFirstLoad(true);
  // }, [searchTerm])
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm) {
        setIsLoadingValue(true);
        if (switchTabValue === 0) {
          searchApiForFabric(searchTerm);
        } else {
          searchApiForBedding(searchTerm);
        }
      }
    }, 700);

    return () => clearTimeout(timer);
  }, [searchTerm, switchTabValue]);

  const onChangeSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };

  const dispatch = useDispatch();
    const [featuredProducts, setFeaturedProducts] = useState([]);
    const getFeaturedProductsURL = apiUrl.product.getFeaturedProducts;
    const { data: responseFeaturedProducts, loading: isLoading, error } = useApi(getFeaturedProductsURL);

    useEffect(() => {
        if (!isLoading && responseFeaturedProducts) {
            setFeaturedProducts(responseFeaturedProducts);
        }
    }, [isLoading, responseFeaturedProducts]);

  return (
    <div className='bs-global-search'>
      <div className='bs-global-search__header'>
        <h2 className='bs-global-search__title'>Search In</h2>
        <div className='bs-global-search__input-action-wrap'>
          <div className='bs-global-search__action-wrap'>
            <Tabs value={switchTabValue} onChange={switchHandleChange} aria-label="basic tabs example" className='bs-switch'>
              <Tab
                label={<div className="bs-switch__option">fabric</div>}
                {...a11yProps(0)}
              />
              <Tab
                label={<div className="bs-switch__option">bedding</div>}
                {...a11yProps(1)}
              />
            </Tabs>
          </div>
          <div className='bs-global-search__input-wrap'>
            <div className='lyt-locator__search-field-wrap bs-global-search__search-wrap'>
              <div className='lyt-locator__search-field'>
                <TextField
                  placeholder='Search here'
                  className='lyt-locator__search-input'
                  value={searchTerm}
                  onChange={onChangeSearchTerm}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <button
                          className={`icon bs-global-search__close-icon ${searchTerm !== '' && searchTerm !== null ? 'icon-simple-close' : 'icon-search'}`}
                          onClick={() => setSearchTerm('')}
                        >
                        </button>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className='lyt-locator__search-action'>
                <button className='bs-btn bs-btn__btn-solid'>Search</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bs-section'>
        <div className='bs-section__section-cont bs-global-search__body'>
          <CustomTabPanel value={switchTabValue} index={0}>
            <ul className='bs-global-search__result-wrap'>
              {collectionArr.length === 0 && materialArr.length === 0 && searchTerm !== "" && !isLoadingValue ? (
                <li className='bs-global-search__result-item'>
                  <NoResults searchValue={searchTerm} />
                </li>
              ) : null}
              {collectionArr.length > 0 ?
                <li className='bs-global-search__result-item'>
                  <h3 className='bs-global-search__result-title'>Collections</h3>
                  <ul className='bs-global-search__search-list-wrap'>
                    {collectionArr.map((item, index) => {
                      return (
                        <li className='bs-global-search__search-list-item' key={index}>
                          {/* <div className='bs-global-search__search-item'>
                                        <Link className='bs-global-search__search-item-title'>{item.label}</Link>
                                        <p className='bs-global-search__search-item-desc'>{item.year}</p>
                                    </div> */}
                          <SearchItem
                            imageId={item?.CollectionImages}
                            title={item?.name}
                            desc={item?.description}
                            link={`/collection-detail?id=${item?.collectionId}`}
                          />
                        </li>
                      )
                    })}
                  </ul>
                </li>
                : null}
              {materialArr.length > 0 ?
                <li className='bs-global-search__result-item'>
                  <h3 className='bs-global-search__result-title'>Fabrics</h3>
                  <ul className='bs-global-search__search-list-wrap'>
                    {materialArr.map((item, index) => {
                      return (
                        <li className='bs-global-search__search-list-item' key={index}>
                          {/* <div className='bs-global-search__search-item'>
                                        <Link className='bs-global-search__search-item-title'>{item.label}</Link>
                                        <p className='bs-global-search__search-item-desc'>{item.year}</p>
                                    </div> */}
                          <SearchItem
                            imageId={item?.materialCode}
                            title={item?.collectionName}
                            desc={item?.productCategoryCollectionBase}
                            link={`/sku-detail?id=${item?.materialCode}&collectionId=${item?.collectionId}`}
                            serialNo={item?.serialNo}
                          />
                        </li>
                      )
                    })}
                  </ul>
                </li>
                : null}
            </ul>
          </CustomTabPanel>
          <CustomTabPanel value={switchTabValue} index={1}>
            {/* bedding results */}
            <ul className='bs-global-search__result-wrap'>
              {beddingArr?.length === 0 && searchTerm !== "" && !isLoadingValue ? (
                <li className='bs-global-search__result-item'>
                  <NoResults searchValue={searchTerm} />
                </li>
              ) : null}
              {beddingArr?.length > 0 ?
                <li className='bs-global-search__result-item'>
                  <h3 className='bs-global-search__result-title'>Bedding results</h3>
                  <ul className='bs-global-search__search-list-wrap'>
                    {beddingArr.map((item, index) => {
                      return (
                        <li className='bs-global-search__search-list-item' key={index}>
                          <BeddingSearchItem
                            productImage={item?.imageUrl}
                            productName={item?.name}
                            productPrice={item?.price}
                            productLink={`/product-description/${item?.slug}`}
                          />
                        </li>
                      )
                    })}
                  </ul>
                </li>
                : null}
            </ul>
          </CustomTabPanel>
        </div>
      </div>
      {switchTabValue === 0 ? 
      <div className='bs-section bs-section--typ-grey cm-overflow-hidden'>
        <div className='bs-section__section-head'>
          <h2 className='bs-section__title'>trending collections</h2>
        </div>
        <div className='bs-section__section-cont'>
          <Collections />
        </div>
      </div>:null
      }
      {switchTabValue === 1 ? 
      <div className='bs-section cm-no-padding-horizontal bs-section--typ-grey'>
          <div className='bs-section__section-head'>
              <h2 className='bs-section__title'>Featured Products</h2>
              <p className='bs-section__sub-title'>Bedding, made just for you</p>
          </div>
          <div className='bs-section__section-cont'>
              <Favourites
                  gridGap={16}
                  actionTitle="shop all products"
                  data={featuredProducts}
                  showAddToCart={false}
                  autoplay={true}
              />
          </div>
      </div>:null
      }
    </div>
  )
}

export default Search